import { useEffect } from "react"

import {
  AnimatedToastStack,
  useAnimatedToastStack,
} from "@/components/motion/animated-toast-stack"
import { registerToastDispatcher } from "@/hooks/use-toast"

// Mount-per-page toast viewport over beUI's animated stack. Registers itself
// as the dispatch target for the singleton toast() — see hooks/use-toast.ts
// for why late/pre-mount toasts queue instead of dropping.
export function Toaster() {
  const { toasts, showToast, dismissToast } = useAnimatedToastStack({
    defaultDuration: 4200,
  })

  useEffect(() => {
    registerToastDispatcher(showToast)
    return () => registerToastDispatcher(null)
  }, [showToast])

  return (
    <AnimatedToastStack
      toasts={toasts}
      onDismiss={dismissToast}
      position="bottom-right"
      placement="fixed"
      maxVisible={4}
    />
  )
}
